/**
 * Nordo Smile Animations System
 * Lightweight reveal-on-scroll using IntersectionObserver
 * Respects prefers-reduced-motion
 */

class NordoAnimations {
  constructor() {
    this.revealElements = [];
    this.initializeRevealOnScroll();
  }

  /**
   * Initialize reveal on scroll animation
   */
  initializeRevealOnScroll() {
    // Check if user prefers reduced motion
    const prefersReducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

    if (prefersReducedMotion) {
      // If prefers reduced motion, show all elements immediately
      document.querySelectorAll('.ns-reveal').forEach(element => {
        element.classList.add('is-visible');
      });
      return;
    }

    // Create IntersectionObserver
    const observerOptions = {
      root: null,
      rootMargin: '0px 0px -50px 0px',
      threshold: 0
    };

    const observer = new IntersectionObserver((entries) => {
      entries.forEach(entry => {
        if (entry.isIntersecting) {
          entry.target.classList.add('is-visible');
          observer.unobserve(entry.target);
        }
      });
    }, observerOptions);

    // Observe all reveal elements
    document.querySelectorAll('.ns-reveal').forEach(element => {
      observer.observe(element);
    });
  }

  /**
   * Parallax scroll effect for hero sections
   */
  initializeParallax() {
    const parallaxElements = document.querySelectorAll('[data-parallax]');

    if (!parallaxElements.length || window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
      return;
    }

    let animationId = null;

    const updateParallax = () => {
      parallaxElements.forEach(element => {
        const parallaxValue = window.scrollY * 0.5;
        element.style.transform = `translateY(${parallaxValue}px)`;
      });
    };

    window.addEventListener('scroll', () => {
      cancelAnimationFrame(animationId);
      animationId = requestAnimationFrame(updateParallax);
    }, { passive: true });
  }

  /**
   * Smooth scroll to element
   */
  smoothScrollTo(targetElement, offset = 0) {
    const targetPosition = targetElement.offsetTop - offset;
    window.scrollTo({
      top: targetPosition,
      behavior: 'smooth'
    });
  }
}

// Initialize on DOM ready
document.addEventListener('DOMContentLoaded', () => {
  window.nordoAnimations = new NordoAnimations();
});

// Also initialize if DOM is already loaded
if (document.readyState === 'interactive' || document.readyState === 'complete') {
  window.nordoAnimations = new NordoAnimations();
}
